import React, { useEffect, useState } from "react";
import { ReactElement } from "react";
import { Analytics } from "firebase/analytics";
import { Tracking } from "./Tracking";
import { TrackingContext } from "./TrackingContext";
import { useConfig } from "../hooks/useConfig";

interface TrackingProviderProps {
    firebaseAnalytics?: Analytics;
}

export function TrackingProvider(props: React.PropsWithChildren<TrackingProviderProps>): ReactElement {
    const config = useConfig();
    const [tracking, setTracking] = useState<Tracking>(new Tracking());

    useEffect(() => {
        const initialize = async () => {
            //console.log("initializing tracking provider");

            const trackingId = config.GOOGLE_ANALYTICS_UNIVERSAL_TRACKING_ID;
            if (trackingId) {
                const trackingInstance = new Tracking();
                if (props.firebaseAnalytics) {
                    try {
                        trackingInstance.initialize(props.firebaseAnalytics, trackingId);
                        console.log("tracking provider initialized");
                    } catch (error) {
                        console.warn("Failed to initialize tracking (analytics may be blocked):", error);
                    }
                }
                setTracking(trackingInstance);
            } else {
                console.warn("missing tracking id for google analytics universal tracking. tracking provider cannot be initialized!");
            }
        };
        
        // Always initialize tracking, even without analytics
        initialize();
    }, [props.firebaseAnalytics, config]);

    return <TrackingContext.Provider value={{ track:  tracking }}>{props.children}</TrackingContext.Provider>;
}
